module.exports = __webpack_public_path__ + "static/img/banner.93f18d46.png";